import gql from 'graphql-tag';

export const UPDATE_PROPOSAL = gql`
  mutation UpdateProposal($id: ID, $fieldsObj: updateProposalFields) {
    updateProposal(id: $id, fieldsObj: $fieldsObj)
  }
`;
